import { Component, Input, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { DomStorageFallbackService } from '../../services/DomStorageFallback.service';

@Component({
    selector: 'al-fb-loader',
    templateUrl: './al-fb-loader.component.html',
    providers: [DomStorageFallbackService]
})
export class FBLoaderComponent implements AfterViewInit, OnDestroy {

    public relaySpinnerTimer;

    // setting ID for loading instance
    @Input() id: string;

    // Checking initial state should visible or not
    @Input() initialShow: boolean;

    // setting component type to load
    @Input() componentType: string;

    // set a Message for loader
    @Input() loadingText: string;

    // set type of loader, default is module
    @Input() loadingType: string = 'moduleLevel';

    // Only loading icon only, default is false
    @Input() loadingIconOnly: boolean = false;

    public loadingMessages: any[];

    /**
     * @constructs
     * Seting constructor method and required param
     *
     * @param _element
     *
     */
    /* istanbul ignore next */
    constructor(private _element: ElementRef, private domStorageFB: DomStorageFallbackService) {

    }

    /**
     * Show indicator using ID
     *
     * @method showIndicator
     * @param elemId
     * @param targetId
     *
     */
    /* istanbul ignore next */
    showIndicator(elemId, targetId) {
        document.querySelector(elemId).children[0].style.display = 'block';
        document.querySelector(elemId).children[0].setAttribute('aria-busy', true);

        if (targetId) {
            document.querySelector(elemId).children[0].style.display = 'none';
            if (this._element.nativeElement.querySelector('.loading-indicator-fieldLevel')) {
                document.querySelector(targetId).appendChild(this._element.nativeElement.querySelector('.loading-indicator-fieldLevel'));
            }
        }
    }

    /**
     * Hide indicator using ID
     *
     * @method hideIndicator
     * @param elemId
     * @param targetId
     *
     */
    /* istanbul ignore next */
    hideIndicator(elemId, targetId) {
        document.querySelector(elemId).children[0].style.display = 'none';
        document.querySelector(elemId).children[0].setAttribute('aria-busy', false);

        let relaySpinnerTimerId = document.querySelector(elemId).children[0].getAttribute('data-timer-id');
        this.clearLoadingSpinnerTimer(relaySpinnerTimerId);
    }


    public _window(): any {
        // return the native window obj
        return window;
    }

    clearLoadingSpinnerTimer(timerId) {
        if (timerId) {
            clearInterval(timerId);
        }
    }

    /**
     * Initializing loading component once its view is available
     *
     * @event ngAfterViewInit
     *
     */
    /* istanbul ignore next */
    ngAfterViewInit() {
        if (this.loadingType === 'pageLevel') {
            document.querySelector('body').appendChild((this._element.nativeElement as HTMLElement));
            this._element.nativeElement.children[0].classList.add('onbody');
        }
    }

    /* istanbul ignore next */
    ngOnDestroy() {
        if (this._element.nativeElement) {
            if (this._element.nativeElement.hasOwnProperty('remove')) {
                this._element.nativeElement.remove();
            } else {
                if (this._element.nativeElement.parentNode) {
                    this._element.nativeElement.parentNode.removeChild(this._element.nativeElement);
                }
            }
        }
    }

}
